import React from 'react';

import PropTypes from 'prop-types';

import styles from './BackToTopButton.module.css';
import { PromoButton } from '../promo-button/PromoButton';

export const BackToTopButton = (props) => {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={styles.buttonContainer}>
            <PromoButton caption={props.caption} variant={'secondary'} iconName={'arrow-up'} onClick={scrollToTop} />
        </div>
    );
};

BackToTopButton.propTypes = {
    caption: PropTypes.string,
};
